import { DNSRecord } from '@va/shared/api/custom-domains';
import { HorizontalScroll } from '@va/ui/design-system';
import { DNSTableRow } from './DNSTableRow';

// index & flag if verification was successfull or not
export type DNSVerificationStatusMap = Record<number, boolean>;

export const DNSRecordsTable = ({
  records,
  expectedRecordsCount,
  dnsVerificationStatusMap,
}: {
  records?: DNSRecord[];
  customDomain: string;
  expectedRecordsCount: number;
  dnsVerificationStatusMap?: DNSVerificationStatusMap;
}) => {
  return (
    <HorizontalScroll>
      <div className='min-w-[31.25rem]'>
        <div className='grid grid-cols-[auto_auto_1fr] w-full font-sans text-sm'>
          {!records &&
            Array.from(Array(expectedRecordsCount)).map((_, i) => {
              return <DNSTableRow key={i} record={undefined} isLoading={true} />;
            })}
          {records?.map((rec, idx) => {
            return (
              <DNSTableRow
                key={rec.value + rec.type}
                verified={dnsVerificationStatusMap?.[idx]}
                record={rec}
                isLoading={false}
              />
            );
          })}
        </div>
      </div>
    </HorizontalScroll>
  );
};
